import { render, staticRenderFns } from "./BotoesArea.vue?vue&type=template&id=69eaa527&"
import script from "./BotoesArea.vue?vue&type=script&lang=js&"
export * from "./BotoesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports